import { app_comment } from '@axo/shared/data-access/types';
import { send } from '../../lib/send';
import { IAPI } from '../../lib/models/api';

export function getAppComment({ url: { service: baseURL }, token }: IAPI) {
  return ({
    applicationID,
  }: {
    applicationID: string;
  }): Promise<app_comment.AppComment> =>
    send({
      baseURL,
      token,
      path: `ace/app-comments/${applicationID}`,
      method: 'GET',
    });
}

export function patchAppComment({ url: { service: baseURL }, token }: IAPI) {
  return async ({
    applicationID,
    patchData,
  }: {
    applicationID: string;
    patchData: app_comment.PatchComment;
  }): Promise<app_comment.PatchComment> =>
    send({
      baseURL,
      token,
      path: `ace/app-comments/${applicationID}`,
      method: 'PATCH',
      body: patchData,
    });
}
